import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

/** Small uppercase blue label used to group content sections. */
const GroupLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.staticPages.blue,
  fontWeight: 700,
}));

GroupLabel.defaultProps = { variant: 'eyebrow' };

export default GroupLabel;
